'use client';

import { SignInButton } from '@clerk/nextjs';
import { Menu } from 'lucide-react';
import Link from 'next/link';
import { useState } from 'react';

import { RequestAccessDrawer } from '@components/landing/RequestAccessDrawer';
import { landingContent } from '@components/landing/content';
import { Button } from '@components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger
} from '@components/ui/sheet';

const LoginButton = ({ className }: { className?: string }) => (
  <SignInButton forceRedirectUrl="/" fallbackRedirectUrl="/">
    <Button variant="ghost" className={className}>
      Log in
    </Button>
  </SignInButton>
);

export function MarketingHeaderActions() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="hidden items-center gap-2 lg:flex">
        <LoginButton />
        <RequestAccessDrawer
          presentation="dark"
          trigger={<Button variant="outline">Request access</Button>}
        />
      </div>

      <div className="lg:hidden">
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" aria-label="Open menu">
              <Menu />
            </Button>
          </SheetTrigger>
          <SheetContent
            side="right"
            className="dark w-[min(88vw,360px)] border-border bg-background text-foreground"
          >
            <SheetTitle className="font-mono text-meta tracking-wider uppercase">
              Navigate LQD
            </SheetTitle>
            <div className="mt-10 flex flex-col gap-2">
              {landingContent.navigation.map(item => (
                <Link
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="flex min-h-11 items-center border-b border-border py-3 text-card-title text-foreground"
                >
                  {item.label}
                </Link>
              ))}
            </div>
            <div className="mt-8 grid gap-3">
              <LoginButton className="w-full" />
              <RequestAccessDrawer
                presentation="dark"
                trigger={
                  <Button
                    variant="outline"
                    className="w-full"
                    onClick={() => setOpen(false)}
                  >
                    Request access
                  </Button>
                }
              />
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </>
  );
}
